import { http, HttpResponse } from 'msw';

import { mockTruktTmsApiUrl } from '../mocks';
import {
  CommodityDecodeVinRequest,
  CommodityDecodeVinResponse,
  CommodityTypesSearchResponse,
} from '..';

export const handlers = [
  http.get(mockTruktTmsApiUrl('/commodities/types'), () => {
    return HttpResponse.json<CommodityTypesSearchResponse>({
      page: 0,
      rows: 5,
      total: 5,
      results: [
        {
          type: 'vehicle',
          isDefault: false,
        },
        {
          type: 'other',
          isDefault: false,
        },
        {
          type: 'bulk',
          isDefault: false,
        },
        {
          type: 'crushed cars',
          isDefault: false,
        },
        {
          type: 'pallets',
          isDefault: false,
        },
      ],
    });
  }),

  http.post(mockTruktTmsApiUrl('/commodity/decodevins'), async ({ request }) => {
    const data = (await request.json()) as CommodityDecodeVinRequest['body'];
    const { vins } = data;

    return HttpResponse.json<CommodityDecodeVinResponse>(
      vins.map((vin) => ({
        vin: vin || '1GKFK16K6RJ401234',
        year: '1994',
        make: 'GMC',
        model: 'Suburban',
        type: '4WD/4-Wheel Drive/4x4',
        trim2: '1/2 ton nominal',
        bodyClass: 'Sport Utility Vehicle (SUV)/Multi-Purpose Vehicle (MPV)',
        vehicleType: 'MULTIPURPOSE PASSENGER VEHICLE (MPV)',
        fuelTypePrimary: 'Gasoline',
        GVWR: 'Class 2F: 7,001 - 8,000 lb (3,175 - 3,629 kg)',
        vehicleWeightClass: {
          label: '2',
          value: '2',
          isDefault: false,
        },
        customType: 'SUV',
        Series: 'Conventional Cab',
      })),
    );
  }),
];
